import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

const Polaroid = ({ fluid, ...other }) => (
  <Container {...other}>
    <Img fluid={fluid} />
  </Container>
);

const Container = styled.figure`
  margin: 0;
  width: 100%;
  height: auto;
  box-shadow: 0px 3.42814px 28.7221px rgba(64, 64, 64, 0.05);

  img {
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 0.6rem;
  }
`;

export default Polaroid;
